import { ILookupManufacturer } from '../item-write/item.models';

/**
 * The manufacturer's logo path by id, through `/lookups/manufacturers` (HUBX-8489).
 *
 * v2 puts no logo on the listing row: it is manufacturer-level reference data, resolved by
 * `manufacturerId` exactly as the name is. This returns what legacy put on each row as
 * `manufacturerLogoUrl`, so a consumer can switch over without changing how it renders:
 *
 * - the stored path, VERBATIM and relative. The consumers (offer-cancellation-warning, the
 *   notifications) prefix `environment.imageBaseUrl` themselves; resolving here would double
 *   the host.
 * - `''` when there is no logo, which is what legacy `GetManufacturerLogo` returns — not null.
 *   Also `''` for a manufacturer the lookup does not list: it serves active manufacturers
 *   only, and a deactivated one resolves to neither name nor logo (decided in HUBX-8489).
 */
export function manufacturerLogoPath(
  manufacturers: readonly ILookupManufacturer[] | null | undefined,
  manufacturerId: string | null | undefined
): string {
  if (!manufacturers || !manufacturerId) { return ''; }
  return manufacturers.find(m => m.id === manufacturerId)?.logoUrl ?? '';
}
